import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: []
})
export class HomeComponent implements OnInit {
  
  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {

  	let t:string = "Ayuda a aliviar los síntomas de la colitis desde la raíz | Sinuberase";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Ayuda a aliviar los síntomas de la colitis desde la raíz | Sinuberase",
  		description: "Sinuberase ofrece la concentración óptima de probióticos que tu cuerpo necesita para restaurar el equilibrio de la flora intestinal. Fortalece tu salud digestiva",
  		slug: "productos"
  	})

  	this.seo.closeMenu();
  }

}
